// frontend/src/pages/ProjectFinancing.tsx
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useProjectFormStore } from "@/store/project-form-provider";
import { ProjectInputField } from "@/components/project-input-field";
import { ProjectSaveButton } from "@/components/project-save-button";
import { ProjectResetButton } from "@/components/project-reset-button";

export default function ProjectFinancing() {
  const { loading, error, formData, updateField, saveAll, resetAll, savingAll, getFieldType, getFieldOptions,
  } = useProjectFormStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name, value);
  };

  const { t } = useTranslation();

  if (loading) return <div className="p-4 text-xs">{t("common.loading")}</div>;
  if (error || !formData) return <div className="p-4 text-elani text-xs">{t("common.error_loading_data")}</div>;

  return (
    <form className="max-w-md space-y-8 text-xs">
      <div className="space-y-2">
        <ProjectInputField label={t("project.financing.debt_type")} name="debt_type" value={formData.debt_type} type={getFieldType("debt_type")} options={getFieldOptions("debt_type")} onChange={handleChange} />
        <ProjectInputField label={t("project.financing.debt_ratio")} name="debt_ratio" value={formData.debt_ratio} type={getFieldType("debt_ratio")} onChange={handleChange} />
        <ProjectInputField label={t("project.financing.interest_rate") + " (" + t("project.financing.interest_rate_unit") + ")"} name="interest_rate" value={formData.interest_rate} type={getFieldType("interest_rate")} onChange={handleChange} />
      </div>
    
      <div className="space-y-2">
        <ProjectInputField label={t("project.financing.debt_start_date")} name="debt_start_date" value={formData.debt_start_date} type={getFieldType("debt_start_date")} onChange={handleChange} />
        <ProjectInputField label={t("project.financing.debt_duration") + " (" + t("units.years") + ")"} name="debt_duration" value={formData.debt_duration} type={getFieldType("debt_duration")} onChange={handleChange} />
        <ProjectInputField label={t("project.financing.repayment_grace_months") + " (" + t("units.months") + ")"} name="repayment_grace_months" value={formData.repayment_grace_months} type={getFieldType("repayment_grace_months")} onChange={handleChange} />
        <ProjectInputField label={t("project.financing.payment_frequency")} name="payment_frequency" value={formData.payment_frequency} type={getFieldType("payment_frequency")} options={getFieldOptions("payment_frequency")} optionLabelKeyPrefix="project.financing.payment_frequency_options" onChange={handleChange} />
        <ProjectInputField label={t("project.financing.debt_structuring_costs")} name="debt_structuring_costs" value={formData.debt_structuring_costs} type={getFieldType("debt_structuring_costs")} onChange={handleChange} />
        <ProjectInputField label={t("project.financing.debt_disagio")} name="debt_disagio" value={formData.debt_disagio} type={getFieldType("debt_disagio")} onChange={handleChange} />
      </div>

      <div className="pt-3 flex gap-2">
        <ProjectSaveButton onSave={saveAll} saving={savingAll} />
        <ProjectResetButton onReset={resetAll} saving={savingAll} />
      </div>
    </form>
  );
}